
import { ActivatedRoute, Router } from '@angular/router';
import { BusyService } from '../_services/busy.service';
import { MenuItem, MessageService } from 'primeng/api';
import { AppComponent } from '../app.component';
import { AuthService } from '@auth0/auth0-angular';
import { GlobalService } from '../_services/global.service';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { datasetsimple } from 'src/types/event';
import { bmxurl } from 'src/globals';
import { booking_returndata } from 'src/types/booking_returndata';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { bookingfee_returndata } from 'src/types/bookingfee_returndata';
import { cBookingfee } from 'src/types/bookingfee';

@Component({
  selector: 'app-alternativefrontpage',
  templateUrl: './alternativefrontpage.component.html',
  styleUrls: ['./alternativefrontpage.component.css']
})
export class AlternativefrontpageComponent  implements OnInit {
  AccessAllowed: boolean = true;
  CompletedLoading: boolean = true;
  weeklydata: any;
  options: any;
  chart: any;
  platformId = inject(PLATFORM_ID);
  todayDate: Date = new Date();

  basicOptions: any;
  chartData: any;
  cols: any[];
  ListBookings: any[];
  ListBookingsGlobal: any[];
  CreateUpdateResponse: any;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  BookingDate: Date;
  TotalNumberThisWeek: number = 0;
  TotalNumberLastWeek: number = 0;
  TotalValueLastWeek: number = 0;
  TotalValueThisWeek: number = 0;
  admissionData: any = [];
  DayResponse: any;
  DayResponseLastWeek: any;
  BookingsToday: number = 0;
  AdmissionsToday: number = 0;
  messages: any = [];

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
    httpResponse: any;
    screenwidth: number;

   constructor(
      private http: HttpClient, 
      private appComp: AppComponent, 
      private router: Router, 
      private messageService: MessageService, 
      private busyService: BusyService,
      private auth: AuthService,
      private globalService: GlobalService,
      private route: ActivatedRoute) {
    }

    loadgrid(showdisabled: boolean)
    {
        this.busyService.busy();
        this.http.get(bmxurl + "acknowledgelist/" + this.VenueID).subscribe(response => {
        try{
            this.CreateUpdateResponse = (response as booking_returndata);

            //Get VenueDate
            this.ListBookings = this.CreateUpdateResponse.data;
            
        }
        catch (error){
            this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'Failed to get bookings in loadgrid, possible data mismatch!'});
        }
        finally{
            this.busyService.idle();
        }
        }, error => {
            this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'An error occurred getting Bookings'});
            this.busyService.idle();
        });
    }

    acknowledge(BID)
    {
      this.http.get(bmxurl + "acknowledge/" + this.VenueID + "/" + BID).subscribe(response => {
        this.CreateUpdateResponse = response
        if(this.CreateUpdateResponse.succeeded)
        {
          this.messageService.add({severity:'success', summary:'Acknowledged', detail:'Booking successfully acknowledged'});
          this.loadgrid(false);
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Acknowledged', detail: 'An error occurred acknowledging this Booking'});
      })
    }

    getBackColour(inMsg: any)
    {
        let styling = ""
        if(new Date(inMsg.datetime).getTime() >= this.addHours(new Date(), 4).getTime())
            styling = "background-color: #eeffee;width: 100%;padding: 15px;border-radius: 7px;color: black;font-weight: bold;margin-bottom: 6px;border: 1px solid #e1e1e1;";
        
        if(new Date(inMsg.datetime).getTime() < this.addHours(new Date(), 4).getTime())
            styling = "background-color: #fff8d6;width: 100%;padding: 15px;border-radius: 7px;color: black;font-weight: bold;margin-bottom: 6px;border: 1px solid #e1e1e1;";
        
        if(new Date(inMsg.datetime).getTime() < this.addHours(new Date(), 2).getTime())
            styling = "background-color: #ffeeee;width: 100%;padding: 15px;border-radius: 7px;color: black;font-weight: bold;margin-bottom: 6px;border: 1px solid #e1e1e1;";

        return styling
    }

    addHours(date: Date, hours: number): Date {
        date.setHours(date.getHours() + hours);
        return date;
      }

    getdashboardData(datapassedin) {
        //Load day data
        this.http.get(bmxurl + "dashboarddaydata/" + this.VenueID + "/" + datapassedin).subscribe(response => {
            try{
                this.DayResponse = (response as any);
                const documentStyle = getComputedStyle(document.documentElement);

                this.BookingsToday = this.DayResponse.data.bookingstoday;
                this.AdmissionsToday = this.DayResponse.data.admissionstoday;

                this.messages = this.DayResponse.data.messages
                
                let colourbnum = 0;
                let colourarray = [
                    "#36a2eb",
                    "#ff6384",
                    "#ff9f40",
                    "#ffcd56",
                    "#4bc0c0",
                ];

                let newLabels: string[] = [];
                let newData: number[] = [];

                let AdmissionCounter = 0;
                let othervalue = 0;
                let othertotalvalue = 0;

                let newAdmissionData: any = [];

                if(this.DayResponse.data.admissions != null)
                {
                    this.DayResponse.data.admissions.forEach((thisweek: any) => {

                        if(AdmissionCounter < 4)
                        {
                            newAdmissionData = {
                                colour: colourarray[colourbnum],
                                admissionid: thisweek.admissionid,
                                name: thisweek.name,
                                totalnumber: thisweek.totalnumber,
                                totalvalue: thisweek.totalvalue,
                            }

                            newLabels.push(thisweek.name);
                            newData.push(thisweek.totalnumber);
                            this.admissionData.push(newAdmissionData);
                            
                        }
                        else
                        {
                            othervalue += thisweek.totalnumber;
                            othertotalvalue += thisweek.totalvalue;

                            newAdmissionData = {
                                colour: colourarray[4],
                                admissionid: thisweek.admissionid,
                                name: "Other",
                                totalnumber: othervalue,
                                totalvalue: othertotalvalue,
                            }
                        }

                        this.TotalNumberThisWeek += thisweek.totalnumber;
                        this.TotalValueThisWeek += thisweek.totalvalue;

                        AdmissionCounter++;
                        colourbnum++;
                    });
                }
                
                if(othervalue > 0)
                    {
                        newLabels.push("Other");
                        newData.push(othervalue);

                        this.admissionData.push(newAdmissionData);
                    }
           
                let newDataSet: datasetsimple = {
                    label: "",
                    data: newData,
                }
            
                this.chartData = {
                    labels: newLabels,
                    datasets: [newDataSet],
                    backgroundColor: [documentStyle.getPropertyValue('--p-cyan-500'), documentStyle.getPropertyValue('--p-orange-500'), documentStyle.getPropertyValue('--p-gray-500'), documentStyle.getPropertyValue('--p-yellow-500'), , documentStyle.getPropertyValue('--p-green-500')],
                    hoverBackgroundColor: [documentStyle.getPropertyValue('--p-cyan-400'), documentStyle.getPropertyValue('--p-orange-400'), documentStyle.getPropertyValue('--p-gray-400'), documentStyle.getPropertyValue('--p-yellow-400'), , documentStyle.getPropertyValue('--p-green-400')]
                }

                //Do weekly data


                // let newDate = new Date();

                // //set newDate to 7 days before datepassedin
                // let yearpassedin = datapassedin.substring(4, 8);
                // let monthpassedin = datapassedin.substring(2, 4);
                // let daypassedin = datapassedin.substring(0, 2);

                // newDate.setDate(new Date(yearpassedin, monthpassedin, daypassedin).getDate() - 7);
                // let BookingDateYearFull1 = newDate.getFullYear();
                // let BookingDateMonth1 = ('00' + (newDate.getMonth() + 1)).slice(-2);
                // let BookingDateDay1 = ('00' + newDate.getDate()).slice(-2);

                // let newDateString = BookingDateDay1 + BookingDateMonth1 + BookingDateYearFull1;

            
                // this.http.get(bmxurl + "dashboarddaydata/" + this.VenueID + "/" + newDateString).subscribe(response => {
                //     try{
                //         this.DayResponseLastWeek = (response as any);

                //         // if(this.DayResponseLastWeek.messages.length > 0)
                //         // {
                //         //     this.messageService.add({severity:'error', summary:'Message', detail: this.DayResponseLastWeek.messages[0]});
                //         // }

                
                //     }
                //     catch (error){
                //         this.messageService.add({severity:'error', summary:'Error getting day data', detail: 'Failed to get day data'});
                //     }
                //     finally{
                //         this.busyService.idle();
                //     }
                //     }, error => {
                //     this.messageService.add({severity:'error', summary:'Error getting day data', detail: 'An error occurred getting day data'});
                //     this.busyService.idle();
                // });


            }
            catch (error){
                this.messageService.add({severity:'error', summary:'Error getting day data', detail: 'Failed to get day data'});
            }
            finally{
                this.busyService.idle();
            }
            }, error => {
            this.messageService.add({severity:'error', summary:'Error getting day data', detail: 'An error occurred getting day data'});
            this.busyService.idle();
        });
    }

    editdatanew(ID){
        localStorage.setItem("homeitem", "TRUE");
        this.router.navigateByUrl("/editbooking/" + ID + "/" + this.BookingDate.toISOString().substring(0,10));
      }

    ngOnInit(): void {
        
            this.globalService.setSmallScreenMenu(false);
        
            addEventListener("resize", (event) => {
              this.screenwidth = window.innerWidth;
            });
        
            this.BookingDate = new Date();
        
            if(this.route.snapshot.paramMap.get('startdate') != null && this.route.snapshot.paramMap.get('startdate') != 'null')
            {
              this.BookingDate = new Date(this.route.snapshot.paramMap.get('startdate'));
            }
        
            localStorage.removeItem("screenMemoryBookingss");
            localStorage.removeItem("screenMemoryEvents");
        
            let menuItems: MenuItem[];
        
            let userid = localStorage.getItem("SmartUserID");
        
            this.http.get(bmxurl + "User/" + userid).subscribe(response => {
              this.httpResponse = (response as any)
              if(this.httpResponse.succeeded)
              {
                let user = this.httpResponse.data;
        
                let Home = localStorage.getItem("ChosenHomePage") == null ? "/home" : "/" + localStorage.getItem("ChosenHomePage")!;

                // menuItems = [{
                //   label: 'ADMIN',
                //   items: [
 
                    
                //               {label: 'Home', icon: 'pi pi-home', routerLink: ['/home'], visible: true},
                //                          // {label: 'Bookings Created Today', icon: 'pi pi-check-circle', routerLink: ['/bookingcreatedtoday'], visible: true},
                //                           {label: 'Bookings List', icon: 'pi pi-align-justify', routerLink: ['/bookinglist'], visible: true},
                //                           {label: 'At a Glance', icon: 'pi pi-eye', routerLink: ['/ataglance'], visible:  true},  
                //                           //{label: 'App QR Code', icon: 'pi pi-qrcode', routerLink: ['/qrcode'], visible:  true},  
                //                           {label: 'Make A Booking', icon: 'pi pi-calendar', routerLink: ['/booking/0'], visible:  true},
                //                           {label: 'Sell Memberships', icon: 'pi pi-users', routerLink: ['/sellmemberships'], visible:  true},
                //                           {label: 'Manage Memberships', icon: 'pi pi-users', routerLink: ['/membershiplist'], visible:  true},
                //                           {label: 'Sell Scheduled Sessions', icon: 'pi pi-users', routerLink: ['/sellscheduledsession'], visible:  true},
                //                           {label: 'Manage Sessions', icon: 'pi pi-calendar', routerLink: ['/scheduledsessionlist'], visible:  true},
                //                           {label: 'Sell Gift Vouchers', icon: 'pi pi-ticket', routerLink: ['/sellavoucher'], visible: true},
                //                           {label: 'Manage Gift Vouchers', icon: 'pi pi-shopping-bag', routerLink: ['/voucherlist'], visible: true}, 
                //                           {label: 'Admissions', icon: 'pi pi-user', routerLink: ['/admission'], visible:  true},
                //                           {label: 'Booking Fees', icon: 'pi pi-money-bill', routerLink: ['/bookingfeeedit'], visible:  true},
                //                           {label: 'Booking Questions', icon: 'pi pi-question-circle', routerLink: ['/bookingquestions'], visible:  true},
                //                           {label: 'Booking Questionnaires', icon: 'pi pi-list', routerLink: ['/bookingquestionnaire'], visible:  true},
                //                           //{label: 'Booking Questions Report', icon: 'pi pi-align-justify', routerLink: ['/bookinganswersreport'], visible:  true},
                //                           {label: 'Cash up', icon: 'pi pi-print', routerLink: ['/cashuplist'], visible:  true},
                //                           {label: 'Confirmations', icon: 'pi pi-at', routerLink: ['/confirmations'], visible:  true},
                //                           {label: 'Classes', icon: 'pi pi-users', routerLink: ['/class'], visible:  true},
                //                           {label: 'Daysheet', icon: 'pi pi-align-left', routerLink: ['/daysheetstyle1'], visible:  true}, 
                //                           {label: 'Deposit Policies', icon: 'pi pi-wallet', routerLink: ['/depositpolicies'], visible: true},
                //                           {label: 'Discounts', icon: 'pi pi-arrow-circle-down', routerLink: ['/discounts'], visible:  true},
                //                           {label: 'Email Templates', icon: 'pi pi-envelope', routerLink: ['/emailtemplates'], visible:  true},
                //                           {label: 'Events', icon: 'pi pi-ticket', routerLink: ['/event'], visible: true}, 
                //                           {label: 'Extras', icon: 'pi pi-star', routerLink: ['/extra'], visible:  true},
                //                           //{label: 'Extras Report', icon: 'pi pi-align-justify', routerLink: ['/extrasreport'], visible:  true},
                //                           {label: 'Link Manager', icon: 'pi pi-link', routerLink: ['/linkmanager'], visible:  true},
                //                           //{label: 'Marketing', icon: 'pi pi-send', routerLink: ['/marketing'], visible:  true},
                //                           {label: 'Membership Set-up', icon: 'pi pi-users', routerLink: ['/memberships'], visible:  true},
                //                           {label: 'Package', icon: 'pi pi-box', routerLink: ['/package'], visible:  true},
                //                           {label: 'Package Groups', icon: 'pi pi-clone', routerLink: ['/packagegroups'], visible:  true},
                //                           {label: 'Package Rules', icon: 'pi pi-tag', routerLink: ['/packagerule'], visible:  true},
                //                           //{label: 'Package Upgrades', icon: 'pi pi-arrow-up', routerLink: ['/packageupgrades'], visible: true},
                //                           {label: 'Reports', icon: 'pi pi-align-justify', routerLink: ['/reportspage'], visible: true},
                //                           {label: 'Resources', icon: 'pi pi-clone', routerLink: ['/resource'], visible:  true},
                //                           //{label: 'Resource Adjustments', icon: 'pi pi-sort-alt', routerLink: ['/resourceadjustments'], visible:  true},
                //                           {label: 'Resource Closings', icon: 'pi pi-ban', routerLink: ['/resourceclosings'], visible: true},
                //                           {label: 'Resource Groups', icon: 'pi pi-sitemap', routerLink: ['/resourcegroupnames'], visible: true},
                //                           //{label: 'Subscriptions', icon: 'pi pi-shopping-bag', routerLink: ['/subscriptions'], visible: true},
                //                           {label: 'Scheduled Sessions', icon: 'pi pi-users', routerLink: ['/scheduledsessions'], visible: true, },
                //                           {label: 'Tags', icon: 'pi pi-tags', routerLink: ['/tag'], visible: true},
                //                           {label: 'Task Types', icon: 'pi pi-paperclip', routerLink: ['/tasktypelist'], visible: true},
                //                           {label: 'Task Status List', icon: 'pi pi-list', routerLink: ['/testtask'], visible: true},
                //                           {label: 'Terms & Conditions', icon: 'pi pi-check-square', routerLink: ['/terms'], visible: true},
                                          
                //                           {label: 'Time Sets', icon: 'pi pi-clock', routerLink: ['/timesets'], visible: true},
                //                           {label: 'Upgrades', icon: 'pi pi-arrow-up', routerLink: ['/upgrades'], visible: true},
                //                           {label: 'User Management', icon: 'pi pi-user', routerLink: ['/users'], visible: true},
                //                           {label: 'Venue Closings', icon: 'pi pi-lock', routerLink: ['/venueclosings'], visible: true},
                //                           {label: 'Venue Settings', icon: 'pi pi-cog', routerLink: ['/venuesettings'], visible: true}, 
                                          
                //                           {label: 'Warnings', icon: 'pi pi-info-circle', routerLink: ['/warnings'], visible: true},
                              
                //                           // {label: 'Till', icon: 'pi pi-shopping-bag', routerLink: ['/till'], visible: true},
                //                           // {label: 'Till Departments', icon: 'pi pi-table', routerLink: ['/tilldepartments'], visible: true},
                              
                //                           //{label: 'Reports', icon: 'pi pi-info-justify', routerLink: ['/reports'], visible: true},
                              
                //                           //{label: 'Booking Calendar', icon: 'pi pi-calendar', routerLink: ['/bookingcalendar'], visible: true},
                              
                //                           //{label: 'Create New Customer', icon: 'pi pi-cog', routerLink: ['/create'], visible: true}, 
                //                           //{label: 'Add Venue to Business', icon: 'pi pi-cog', routerLink: ['/addvenuetobusiness'], visible: true}, 
                              
                //                           {label: 'Dashboard (BETA)', icon: 'pi pi-lock', routerLink: ['/altfrontpage'], visible: true},
                               
                //   ]
                // }];
        
                menuItems =
                    [
                    {label: 'Home', icon: 'pi pi-home', routerLink: [Home]},
                    {label: 'Make A Booking', icon: 'pi pi-calendar', routerLink: ['/booking/0']},
                    {label: 'Quick Book', icon: 'pi pi-telegram', routerLink: ['/booking/0/true']},
                    {
                        label: 'Sell',
                        items: [
                        {label: 'Bookings', icon: 'pi pi-calendar', routerLink: ['/booking/0']},
                        {label: 'Events', icon: 'pi pi-ticket', routerLink: ['/event']}, 
                        {label: 'Gift Vouchers', icon: 'pi pi-ticket', routerLink: ['/sellavoucher']},
                        {label: 'Memberships', icon: 'pi pi-users', routerLink: ['/sellmemberships']},
                        {label: 'Quick Book', icon: 'pi pi-telegram', routerLink: ['/booking/0/true']},
                        {label: 'Scheduled Sessions', icon: 'pi pi-users', routerLink: ['/sellscheduledsession']},        
                        {label: 'Till', icon: 'pi pi-shopping-bag', routerLink: ['/till']},
                        ],
                    },
                    {
                        label: 'Views',
                        items: [
                        {label: 'At a Glance', icon: 'pi pi-eye', routerLink: ['/ataglance']},  
                        {label: 'Bookings Created Today', icon: 'pi pi-check-circle', routerLink: ['/home']},
                        {label: 'Bookings List', icon: 'pi pi-align-justify', routerLink: ['/bookinglist']},
                        {label: 'Party List', icon: 'pi pi-align-justify', routerLink: ['/partylist']},
                        {label: 'Daysheet', icon: 'pi pi-align-left', routerLink: ['/daysheetstyle1']}, 
                        ],
                    },
                    {
                        label: 'Booking Questions',
                        items: [
                            
                            {label: 'Booking Questions', icon: 'pi pi-question-circle', routerLink: ['/bookingquestions']},
                            {label: 'Booking Questionnaires', icon: 'pi pi-list', routerLink: ['/bookingquestionnaire']},
                        ]
                    },
                    {
                        label: 'Emails & Confirmations',
                        items: [
                            {label: 'Confirmations', icon: 'pi pi-at', routerLink: ['/confirmations']},
                            {label: 'Email Templates', icon: 'pi pi-envelope', routerLink: ['/emailtemplates']},
                        ]
                    },
                    {
                        label: 'Event Settings',
                        items: [
                        {label: 'Admissions', icon: 'pi pi-user', routerLink: ['/admission']},
                        {label: 'Confirmations', icon: 'pi pi-at', routerLink: ['/confirmations']},
                        {label: 'Deposit Policies', icon: 'pi pi-wallet', routerLink: ['/depositpolicies']},
                        {label: 'Events', icon: 'pi pi-ticket', routerLink: ['/event']}, 
                        {label: 'Tags', icon: 'pi pi-tags', routerLink: ['/tag']},
                        {label: 'Warnings', icon: 'pi pi-info-circle', routerLink: ['/warnings'], visible: true},
                        ]
                    },
                    {
                        label: 'Financial',
                        items: [
                            {label: 'Cash up', icon: 'pi pi-print', routerLink: ['/cashuplist']},
                            {label: 'Reports', icon: 'pi pi-align-justify', routerLink: ['/reportspage']},
                        ]
                    },
                    {
                        label: 'Gift Vouchers',
                        items: [
                            {label: 'Sell Gift Vouchers', icon: 'pi pi-ticket', routerLink: ['/sellavoucher']},
                            {label: 'Manage Gift Vouchers', icon: 'pi pi-shopping-bag', routerLink: ['/voucherlist']}, 
                        ]
                    },
                    {
                        label: 'Memberships',
                        items: [
                        {label: 'Sell Memberships', icon: 'pi pi-users', routerLink: ['/sellmemberships']},
                        {label: 'Manage Memberships', icon: 'pi pi-users', routerLink: ['/membershiplist']},
                        {label: 'Membership Set-up', icon: 'pi pi-users', routerLink: ['/memberships']},
                        ],
                    },
                    {
                        label: 'Package Settings',
                        items: [
                        //{label: 'Add-Ons', icon: 'pi pi-arrow-circle-up', routerLink: ['/admissionbasedupgrades']},
                        {label: 'Admissions', icon: 'pi pi-user', routerLink: ['/admission']},
                        {label: 'Classes', icon: 'pi pi-users', routerLink: ['/class']},
                        {label: 'Confirmations', icon: 'pi pi-at', routerLink: ['/confirmations']},
                        {label: 'Deposit Policies', icon: 'pi pi-wallet', routerLink: ['/depositpolicies']},
                        {label: 'Extras', icon: 'pi pi-star', routerLink: ['/extra']},
                        {label: 'Multi Package Extras', icon: 'pi pi-clone', routerLink: ['/multipackageextras']},
                        {label: 'Package', icon: 'pi pi-box', routerLink: ['/package']},
                        //{label: 'Package Add-Ons', icon: 'pi pi-arrow-circle-up', routerLink: ['/packageaddons'], visible:  true},
                        {label: 'Package Groups', icon: 'pi pi-clone', routerLink: ['/packagegroups']},
                        {label: 'Package Rules', icon: 'pi pi-tag', routerLink: ['/packagerule']},
                        {label: 'Upgrades', icon: 'pi pi-arrow-up', routerLink: ['/upgrades']},
                        {label: 'Tags', icon: 'pi pi-tags', routerLink: ['/tag']},
                        {label: 'Warnings', icon: 'pi pi-info-circle', routerLink: ['/warnings'], visible: true},

                        ],
                    },
                    {
                        label: 'Resources',
                        items: [
                        {label: 'Classes', icon: 'pi pi-users', routerLink: ['/class']},
                        {label: 'Resources', icon: 'pi pi-clone', routerLink: ['/resource']},
                        {label: 'Closings and Adjustments', icon: 'pi pi-ban', routerLink: ['/resourceclosings']},
                        {label: 'Resource Groups', icon: 'pi pi-sitemap', routerLink: ['/resourcegroupnames']},
                        ],
                    },
                    {
                        label: 'Scheduled Sessions',
                        items: [
                        {label: 'Sell Scheduled Sessions', icon: 'pi pi-users', routerLink: ['/sellscheduledsession']},
                        {label: 'Manage Sessions', icon: 'pi pi-calendar', routerLink: ['/scheduledsessionlist']},
                        {label: 'Session Calendar', icon: 'pi pi-calendar', routerLink: ['/scheduledsessioncalendar']},
                        {label: 'Set-up Sessions', icon: 'pi pi-users', routerLink: ['/scheduledsessions']},
                        ],
                    },
                    {
                        label: 'Tasks',
                        items: [
                        {label: 'Task Types', icon: 'pi pi-paperclip', routerLink: ['/tasktypelist']},
                        {label: 'Task Status List', icon: 'pi pi-list', routerLink: ['/testtask']},
                        ],
                    },
                    {
                        label: 'Till',
                        items: [
                        {label: 'Till', icon: 'pi pi-shopping-bag', routerLink: ['/till']},
                        {label: 'Till Departments', icon: 'pi pi-table', routerLink: ['/tilldepartments']},
                        ],
                    },
                    {
                        label: 'Venue Management',
                        items: [
                            {label: 'Booking Fees', icon: 'pi pi-money-bill', routerLink: ['/bookingfee']},
                            {label: 'Cash up', icon: 'pi pi-print', routerLink: ['/cashuplist']},
                            {label: 'Customer Portal', icon: 'pi pi-id-card', routerLink: ['/customerportal']},
                            {label: 'Discounts', icon: 'pi pi-arrow-circle-down', routerLink: ['/discounts'], visible:  true},
                            {label: 'Reports', icon: 'pi pi-align-justify', routerLink: ['/reportspage']},
                            {label: 'Link Manager', icon: 'pi pi-link', routerLink: ['/linkmanager']},        
                            {label: 'Tags', icon: 'pi pi-tags', routerLink: ['/tag']},
                            {label: 'Terms & Conditions', icon: 'pi pi-check-square', routerLink: ['/terms']},
                            {label: 'Time Sets', icon: 'pi pi-clock', routerLink: ['/timesets']},
                            {label: 'User Management', icon: 'pi pi-user', routerLink: ['/users']},
                            {label: 'Venue Closings', icon: 'pi pi-lock', routerLink: ['/venueclosings']},
                            {label: 'Venue Settings', icon: 'pi pi-cog', routerLink: ['/venuesettings']}, 
                            {label: 'Warnings', icon: 'pi pi-info-circle', routerLink: ['/warnings'], visible: true},
                            {label: 'Integrations', icon: 'pi pi-th-large', routerLink: ['/integrations'], visible: true},
                        ]
                    },
                    {
                        label: 'Waivers',
                        items: [
                            {label: 'Manage Statement of Risk', icon: 'pi pi-file', routerLink: ['/statementofrisk']},
                            //{label: 'Manage Waivers', icon: 'pi pi-file', routerLink: ['/managewaivers']},
                        ]
                    },
                    {label: 'Dashboard (BETA)', icon: 'pi pi-lock', routerLink: ['/altfrontpage']},

                    //{label: 'Agreement', icon: 'pi pi-lock', routerLink: ['/agreement/301c162e-0901-4732-b952-afe29c0a9902']}
                    
                    
                ];
                this.globalService.setMenuItems(menuItems);  
        
                this.globalService.setBCItem(['Home','/home']);
        
                let UseCounters = localStorage.getItem("UseCounter")
                this.globalService.setUseCounters(UseCounters);
            
              }
            }, error => {
              this.messageService.add({ severity: 'error', summary: 'Unable to get User' });
            });
        
            this.busyService.busy();
        
            //Get Settings and put them in Local Storage
            this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
                this.httpResponse =  (response as venuesettings_returndata)
                if(this.httpResponse.succeeded)
                {
                //Set Venue Settings ID
                localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);
        
                this.httpResponse.data.venueSettings.forEach(element => {
                    localStorage.setItem(element.name, element.value);
                });
    
                this.CurrencySymbol = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

                if(localStorage.getItem("VoucherEmailTemplate") == null || localStorage.getItem("VoucherEmailTemplate") == "null")
                {
                    localStorage.setItem("VoucherEmailTemplate", "");
                }
            
                this.loadgrid(false);
                }
                else{
                this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
                }
            }, error => {
                this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
            });
        
            // this.http.get(bmxurl + "bookingfee/" + this.VenueID).subscribe(response => {
            //   this.httpResponse = (response as bookingfee_returndata)
            //   if (this.httpResponse.succeeded)
            //   {
            //     if(this.httpResponse.data != null)
            //     {
            //       let BookingFee: cBookingfee = {
            //         id: (this.httpResponse.data as cBookingfee).id,
            //         venueid: (this.httpResponse.data as cBookingfee).venueid,
            //         disabled: (this.httpResponse.data as cBookingfee).disabled,
            //         bfid: (this.httpResponse.data as cBookingfee).bfid,
            //         name: (this.httpResponse.data as cBookingfee).name,
            //         isdefault: (this.httpResponse.data as cBookingfee).isdefault,
            //         bfpublicapply: (this.httpResponse.data as cBookingfee).bfpublicapply,
            //         bfadminapply: (this.httpResponse.data as cBookingfee).bfadminapply,
            //         bfpublicshowtext: (this.httpResponse.data as cBookingfee).bfpublicshowtext,
            //         bfpublictext: (this.httpResponse.data as cBookingfee).bfpublictext,
            //         bfpublictype: (this.httpResponse.data as cBookingfee).bfpublictype,
            //         bfadmintype: (this.httpResponse.data as cBookingfee).bfadmintype,
            //         bfpublicfee: (this.httpResponse.data as cBookingfee).bfpublicfee,
            //         bfpublicmin: (this.httpResponse.data as cBookingfee).bfpublicmin,
            //         bfpublicmax: (this.httpResponse.data as cBookingfee).bfpublicmax,
            //         bfadminfee: (this.httpResponse.data as cBookingfee).bfadminfee,
            //         bfadminmin: (this.httpResponse.data as cBookingfee).bfadminmin,
            //         bfadminmax: (this.httpResponse.data as cBookingfee).bfadminmax,
            //         bookingfeeappliestomemberspublic: (this.httpResponse.data as cBookingfee).bookingfeeappliestomemberspublic,
            //         bookingfeeappliedonmembershippurchasespublic: (this.httpResponse.data as cBookingfee).bookingfeeappliedonmembershippurchasespublic,
            //         bookingfeeappliestomembersadmin: (this.httpResponse.data as cBookingfee).bookingfeeappliestomembersadmin,
            //         bookingfeeappliedonmembershippurchasesadmin: (this.httpResponse.data as cBookingfee).bookingfeeappliedonmembershippurchasesadmin,
            //       };
        
            //       localStorage.setItem("VenueBookingFee", JSON.stringify(BookingFee));
            //     }
            //   }
            //   else
            //   {
            //     this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Booking Fee'});
            //   }
            // }, error => {
            //   this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Booking Fee, error:' + error.messages[0]});
            // });
        

        this.BookingDate = new Date();

        let BookingDateYear = this.BookingDate.getFullYear().toString().substr(-2);
        let BookingDateYearFull = this.BookingDate.getFullYear();
        let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
        let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

        let dateChosen = BookingDateDay + BookingDateMonth + BookingDateYear;
        let dateChosenFull = BookingDateDay + BookingDateMonth + BookingDateYearFull;

        this.getdashboardData(dateChosenFull);
        this.initChart(this.BookingDate);

        this.loadgrid(false);
        
            this.basicOptions = {
            plugins: {
                legend: {
                    display: false
                }
            },
            responsive: true,
            scales: {
                y: {
                    ticks: {
                        display: false,
                    },
                    grid: {
                        display: false
                    }
                },
                x: {
                    ticks: {
                        display: false,
                    },
                    grid: {
                        display: false
                    }
                }
            }
            };

    }

    getWeekdata() {
        this.http.get(bmxurl + "dashboardweekdata/" + this.VenueID).subscribe(response => {
            let returnedData = (response as any).data;
            const documentStyle = getComputedStyle(document.documentElement);

            let lastweekdata: any = [];
            let thisweekdata: any = [];

            lastweekdata.push(returnedData.mondaylastweek);
            lastweekdata.push(returnedData.tuesdaylastweek);
            lastweekdata.push(returnedData.wednesdaylastweek);
            lastweekdata.push(returnedData.thursdaylastweek);
            lastweekdata.push(returnedData.fridaylastweek);
            lastweekdata.push(returnedData.saturdaylastweek);
            lastweekdata.push(returnedData.sundaylastweek);

            thisweekdata.push(returnedData.mondaythisweek);
            thisweekdata.push(returnedData.tuesdaythisweek);
            thisweekdata.push(returnedData.wednesdaythisweek);
            thisweekdata.push(returnedData.thursdaythisweek);
            thisweekdata.push(returnedData.fridaythisweek);
            thisweekdata.push(returnedData.saturdaythisweek);
            thisweekdata.push(returnedData.sundaythisweek);

            this.weeklydata = {
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                
                datasets: [
                    {
                        label: 'Last Week',
                        backgroundColor: documentStyle.getPropertyValue('--p-cyan-500'),
                        borderColor: documentStyle.getPropertyValue('--p-cyan-500'),
                        data: lastweekdata
                    },
                    {
                        label: 'This Week',
                        backgroundColor: documentStyle.getPropertyValue('--p-gray-500'),
                        borderColor: documentStyle.getPropertyValue('--p-gray-500'),
                        data: thisweekdata
                    }
                ]
        }});
    }

    getMonday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }

    initChart(datapassedin) {
    if (isPlatformBrowser(this.platformId)) {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--p-text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
        const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

        //set datapassedin to monday of this week
        // let date = new Date(datapassedin);
        // let monday = this.getMonday(date);

        // let BookingDateYearFull = monday.getFullYear();
        // let BookingDateMonth = ('00' + (monday.getMonth() + 1)).slice(-2);
        // let BookingDateDay = ('00' + monday.getDate()).slice(-2);
        // let dateChosenFull = BookingDateDay + BookingDateMonth + BookingDateYearFull;

        this.getWeekdata();
        this.options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500
                        }
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };
    }
    }

}
